import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen" style={{background:'var(--bg-primary)', color:'var(--text-secondary)'}}>
      <header className="px-8 lg:px-16 py-5 flex items-center justify-between" style={{borderBottom:'1px solid var(--border-color)'}}>
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="AHOOW" className="h-10 w-10 rounded-xl" />
          <span className="text-2xl font-black tracking-wide" style={{color:'var(--text-primary)'}}>AH<span className="text-brand-pink">OO</span>W</span>
        </div>
        <Link to="/" className="text-sm flex items-center gap-2 hover:opacity-70" style={{color:'var(--text-muted)'}} data-testid="terms-back"><ArrowLeft size={16} /> Retour</Link>
      </header>

      <div className="max-w-3xl mx-auto px-8 py-12">
        <div className="flex items-center gap-3 mb-4">
          <FileText size={28} className="text-brand-violet" />
          <h1 className="text-3xl font-black" style={{color:'var(--text-primary)'}}>Conditions Generales d'Utilisation</h1>
        </div>
        <p className="text-sm mb-2" style={{color:'var(--text-muted)'}}>Derniere mise a jour : Avril 2026</p>
        <p className="text-sm mb-8" style={{color:'var(--text-muted)'}}>Entite legale : Ahoow LLC &mdash; 8 The Grn R, Dover, DE 19901-3618, Etats-Unis</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>1. Acceptation des conditions</h2>
            <p>En creant un compte ou en utilisant le Service, vous acceptez les presentes CGU et notre <Link to="/privacy" className="text-brand-violet underline">Politique de Confidentialite</Link>.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>2. Eligibilite</h2>
            <div className="p-4 rounded-xl mb-3" style={{background:'var(--bg-card)', border:'1px solid var(--border-color)'}}>
              <p className="font-bold" style={{color:'var(--text-primary)'}}>Vous devez avoir au moins 18 ans pour utiliser Ahoow.</p>
            </div>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>3. Utilisation du Service</h2>
            <p>Vous vous engagez a utiliser le Service de maniere responsable et respectueuse.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>4. Credits et paiements</h2>
            <p>Les paiements sont traites par Stripe. Les credits ne sont pas remboursables.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>5. Contact</h2>
            <div className="p-4 rounded-xl" style={{background:'var(--bg-card)'}}>
              <p className="font-semibold mb-2" style={{color:'var(--text-primary)'}}>Ahoow LLC</p>
              <p>8 The Grn R, Dover, DE 19901-3618, Etats-Unis</p>
              <p className="mt-2">Support : <a href="mailto:support@ahoow.com" className="text-brand-violet underline">support@ahoow.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
